/**
 * @file loadingSlice.ts
 * @ CopyRight (C) 2021-2022 All rights reserved. Highway9 Networks Inc.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { useAppDispatch, useAppSelector } from "../hooks";
import LoadingX from "../../components/shared/LoadingX";

type initState = {
  open: boolean;

};

const initialState: initState = {
  open: false,
};


const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    }
  },
});

export const loadingActions = loadingSlice.actions;

export const useLoading = () => {
  const loading = useAppSelector((state: RootState) => state.loading.open);
  const dispatch = useAppDispatch();
  const setLoading = (open: boolean) => {
    dispatch(loadingActions.setLoading(open));
  };
  return { loading, setLoading, LoadingComponent: LoadingX };
};

export default loadingSlice.reducer;
